import 'bootstrap/dist/css/bootstrap.min.css';

import {
    API_ADD_CLIENT,API_CENTERS, API_GET_LOANS
} from '../Config/ApiUrlConstant'; // Import your constants

import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import SuccessModal from '../Common/SuccessModal';
import { useAuth } from '../AuthContext'; // Import useAuth hook for access

const branches = [
    {
        "id": 1,
        "branch_no": "BRAN0001",
        "branch_name": "Mohanw"
    }];
const ClientDetailsForm = () => {
    const [formData, setFormData] = useState({
        center_id: '',
        client_name: '',
        client_dob: '',
        contact_no: '',
        client_uid: '',
        client_pan: '',
        client_father_name: '',
        client_mother_name: '',
        client_husband_name: '',
        client_husband_dob: '',
        husband_father_name: '',
        husband_mother_name: '',
        client_address: '',
        client_business: '',
        husband_address: '',
        purpose_of_loan: '',
        // demand_loan_id: '',
        // approve_loan_id: '',
        // demand_loan_amt: '',
        // approve_loan_amt: '',
        client_uid_upload: null,
        client_pan_upload_path: null,
        client_ration_card_upload_path: null,
    });
    const [message, setMessage] = useState('');
    const [modalVisible, setModalVisible] = useState(false);  // State to control modal visibility
    const [loanList, setLoanList] = useState([]);
    const [centerList, setCenterList] = useState([]);    
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == 'branch_id' && value != "") {
            getCenetersByBranch(value);
        }else if(name == 'branch_id' && value == ""){
            setCenterList([])
        }
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({
            ...formData,
            [name]: files[0],
        });
    };
    const { logout } = useAuth(); // Add this at the top inside the component

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log('formData ->', formData);

        const formDataObj = new FormData();

        // Append regular form data to FormData (e.g., text inputs)
        for (const [key, value] of Object.entries(formData)) {
            if (value && key !== 'client_uid_upload' && key !== 'client_pan_upload_path' && key !== 'client_ration_card_upload_path') {
                formDataObj.append(key, value);
            }
        }

        // Append file inputs
        if (formData.client_uid_upload) formDataObj.append('client_uid_upload', formData.client_uid_upload);
        if (formData.client_pan_upload_path) formDataObj.append('client_pan_upload_path', formData.client_pan_upload_path);
        if (formData.client_ration_card_upload_path) formDataObj.append('client_ration_card_upload_path', formData.client_ration_card_upload_path);

        // Log the FormData object (Note: you can't directly log FormData, it won't show its content)
        for (let pair of formDataObj.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        console.log(' formDataObj->', formDataObj)

        // Send the form data to the backend
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(API_ADD_CLIENT, {
                method: 'POST',
                headers: {
                    // 'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: formDataObj, // Note the use of `formDataObj` here
            });

            const responseData = await response.json(); // Parse JSON response
            console.log('responseData ->', responseData)
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            if (responseData.status) {
                setMessage(responseData.message);
                setModalVisible(true);
                resetForm();

                // Auto-close the modal after 3 seconds
                setTimeout(() => {
                    setModalVisible(false);
                }, 3000);
            } else {
                setMessage(responseData.message);
                setModalVisible(false);
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Error adding client');
            setModalVisible(false);
        }
    };

    const getCenetersByBranch = async (branchId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(API_CENTERS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`, 
                },
                body: JSON.stringify({ is_all: false,branch_id:branchId })  // Serialize the body to JSON
            });

            const responseData = await response.json(); // Parse JSON response
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            console.log('responseData ->', responseData)
            setCenterList(responseData.data)
        } catch (error) {
            console.error('Error:', error);
            setMessage('Error get centers');
            setCenterList([])
        }
    }

    // Close the modal
    const closeModal = () => {
        setModalVisible(false);
    };
    const resetForm = () => {
        setFormData({
            branch_id: '',
            center_id: '',
            client_name: '',
            client_dob: '',
            contact_no: '',
            client_uid: '',
            client_pan: '',
            client_father_name: '',
            client_mother_name: '',
            client_husband_name: '',
            client_husband_dob: '',
            husband_father_name: '',
            husband_mother_name: '',
            client_address: '',
            client_business: '',
            husband_address: '',
            purpose_of_loan: '',
            // demand_loan_amt: '',
            // demand_loan_id: '',
            // approve_loan_id: '',
            // approve_loan_amt: '',
            client_uid_upload: null,
            client_pan_upload_path: null,
            client_ration_card_upload_path: null,
        });
    }

    const getAllLoans = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(API_GET_LOANS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`, 
                },
                body: JSON.stringify({ is_all: true })  // Serialize the body to JSON
            });

            const responseData = await response.json(); // Parse JSON response
            console.log('responseData ->', responseData)
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            setLoanList(responseData.data)
        } catch (error) {
            console.error('Error:', error);
            setMessage('Error adding client');
            setModalVisible(false);
        }
    }
    useEffect(() => {
        let loans = getAllLoans();
    }, [])
    return (
        <div className="container mt-5">
            <h2>Client Details Form</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Branch Name * </label>
                    <select
                        className="form-control"
                        name="branch_id"
                        value={formData.branch_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Branch</option>
                        {branches.map(branch => (
                            <option key={branch.id} value={branch.id}>
                                {branch.branch_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Center Name * </label>
                    <select
                        className="form-control"
                        name="center_id"
                        value={formData.center_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Center</option>
                        {centerList.map(center => (
                            <option key={center.id} value={center.id}>
                                {center.center_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Client Name *</label>
                    <input type="text" className="form-control" name="client_name" value={formData.client_name} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Client’s DOB *</label>
                    <input type="date" className="form-control" name="client_dob" value={formData.client_dob} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Contact Number *</label>
                    <input type="text" className="form-control" name="contact_no" value={formData.contact_no} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Client UID *</label>
                    <input type="text" className="form-control" name="client_uid" value={formData.client_uid} onChange={handleChange} required />
                </div>
                {/* <div className="form-group">
                    <label>Client PAN</label>
                    <input type="text" className="form-control" name="client_pan" value={formData.client_pan} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Client’s Father’s Name</label>
                    <input type="text" className="form-control" name="client_father_name" value={formData.client_father_name} onChange={handleChange}  />
                </div>
                <div className="form-group">
                    <label>Client’s Mother’s Name</label>
                    <input type="text" className="form-control" name="client_mother_name" value={formData.client_mother_name} onChange={handleChange}  />
                </div>
                <div className="form-group">
                    <label>Husband Name</label>
                    <input type="text" className="form-control" name="client_husband_name" value={formData.client_husband_name} onChange={handleChange}  />
                </div>
                <div className="form-group">
                    <label>Husband’s DOB</label>
                    <input type="date" className="form-control" name="client_husband_dob" value={formData.client_husband_dob} onChange={handleChange}  />
                </div>
                <div className="form-group">
                    <label>Husband's Father’s Name</label>
                    <input type="text" className="form-control" name="husband_father_name" value={formData.husband_father_name} onChange={handleChange}  />
                </div>
                <div className="form-group">
                    <label>Husband's Mother’s Name</label>
                    <input type="text" className="form-control" name="husband_mother_name" value={formData.husband_mother_name} onChange={handleChange}  />
                </div> */}
                <div className="form-group">
                    <label>Client Address *</label>
                    <textarea className="form-control" name="client_address" value={formData.client_address} onChange={handleChange} required></textarea>
                </div>
                <div className="form-group">
                    <label>Client Business *</label>
                    <input type="text" className="form-control" name="client_business" value={formData.client_business} onChange={handleChange} required />
                </div>
                {/* <div className="form-group">
                    <label>Husband's Address</label>
                    <textarea className="form-control" name="husband_address" value={formData.husband_address} onChange={handleChange} ></textarea>
                </div> */}
                <div className="form-group">
                    <label>Purpose of Loan *</label>
                    <input type="text" className="form-control" name="purpose_of_loan" value={formData.purpose_of_loan} onChange={handleChange} required />
                </div>
                {/* <div className="form-group">
                    <label>Demand Loan Amount *</label>
                    <select
                        className="form-control"
                        name="demand_loan_id"
                        value={formData.demand_loan_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Demand Loan</option>
                        {loanList.map(loan => (
                            <option key={loan.id} value={loan.id}>
                                {loan.loan_amt}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Approved Loan Amount *</label>
                    <select
                        className="form-control"
                        name="approve_loan_id"
                        value={formData.approve_loan_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Approve Loan</option>
                        {loanList.map(loan => (
                            <option key={loan.id} value={loan.id}>
                                {loan.loan_amt}
                            </option>
                        ))}
                    </select>
                </div> */}
                {/* <div className="form-group">
                    <label>Demand Loan Amount</label>
                    <input type="number" className="form-control" name="demand_loan_amt" value={formData.demand_loan_amt} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Approved Loan Amount</label>
                    <input type="number" className="form-control" name="approve_loan_amt" value={formData.approve_loan_amt} onChange={handleChange} required />
                </div> */}
                {/* <div className="form-group">
                    <label>Approved Authority Name</label>
                    <input type="text" className="form-control" name="approvedAuthorityName" onChange={handleChange} required />
                </div> */}
                {/* <div className="form-group">
                    <label>UID Upload</label>
                    <input type="file" className="form-control" name="client_uid_upload" onChange={handleFileChange} />
                </div>
                <div className="form-group">
                    <label>PAN Upload</label>
                    <input type="file" className="form-control" name="client_pan_upload_path" onChange={handleFileChange} />
                </div>
                <div className="form-group">
                    <label>Ration Card Upload</label>
                    <input type="file" className="form-control" name="client_ration_card_upload_path" onChange={handleFileChange} />
                </div> */}
                <button type="submit" className="btn btn-primary">Submit</button>
            </form>
            {/* Display Success Modal if modalVisible is true */}
            {modalVisible && (
                <SuccessModal message={message} onClose={closeModal} />
            )}
        </div>
    );
};

export default ClientDetailsForm;